import React, { useCallback, useRef, useState, useEffect } from 'react';
import Webcam from 'react-webcam';
import APIManager from '../../../connection/ApiManager';
import { translate } from '../../../helper';

const Scanner = (props) => {
    const { handleScannerResponse, setScan, handleClose } = props;
    const webcamRef = useRef(null);
    const canvasRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const lockOrientation = async () => {
            try {
                if (window.screen && window.screen.orientation && window.screen.orientation.lock) {
                    await window.screen.orientation.lock('portrait-primary');
                }
            } catch (error) {
                console.log('Screen orientation lock not supported or failed:', error);
            }
        };

        const unlockOrientation = () => {
            try {
                if (window.screen && window.screen.orientation && window.screen.orientation.unlock) {
                    window.screen.orientation.unlock();
                }
            } catch (error) {
                console.log('Screen orientation unlock failed:', error);
            }
        };

        lockOrientation();

        return () => {
            unlockOrientation();
        };
    }, []);
    
    const captureAndScan = useCallback(async () => {
        const imageSrc = webcamRef.current.getScreenshot();

        const img = new Image();
        img.src = imageSrc;

        img.onload = async () => {
            const canvas = canvasRef.current;
            const ctx = canvas.getContext('2d');
            // Set canvas size to match the image
            canvas.width = img.width;
            canvas.height = img.height;

            // Draw the image onto the canvas
            ctx.drawImage(img, 0, 0);

            // Define the crop area dimensions
            const cropWidth = img.width - 40;
            const cropHeight = img.height * 0.10;

            // Calculate the starting point (center the crop area)
            const cropX = 20;
            const cropY = 0.46 * img.height;

            // Get the cropped image data
            const croppedCanvas = document.createElement('canvas');
            const croppedCtx = croppedCanvas.getContext('2d');
            croppedCanvas.width = cropWidth;
            croppedCanvas.height = cropHeight;
            croppedCtx.drawImage(canvas, cropX, cropY, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);
            // setCroppedImage(croppedCanvas.toDataURL());
            const byteString = atob(croppedCanvas.toDataURL().split(',')[1]);
            const mimeString = croppedCanvas.toDataURL().split(',')[0].split(':')[1].split(';')[0];
            const ab = new ArrayBuffer(byteString.length);
            const ia = new Uint8Array(ab);
            for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            const blob = new Blob([ab], { type: mimeString });
            const formData = new FormData();
            formData.append('image', blob, 'image.jpg');

            try {
                const res = await APIManager.getInstance().ocrScanner(formData);
                handleScannerResponse(res);
            } catch (error) {
                console.error('Error sending image to backend:', error);
            } finally {
                setScan(false);
            }
        };
    }, [webcamRef]);

    const handleUserMedia = () => {
        setIsLoading(true);
    };

    return (
        <div style={{ position: 'relative', width: 'auto' }}>
            <Webcam
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                style={{
                    width: '100%',
                }}
                videoConstraints={{
                    facingMode: 'environment'
                }}
                onUserMedia={handleUserMedia}
            />
            <canvas ref={canvasRef} style={{ display: 'none' }}></canvas>
            {isLoading && (
                <>
                    <div
                        style={{
                            position: 'absolute',
                            color: 'white',
                            top: 0,
                            right: '15px',
                            fontSize: '1.5rem',
                            zIndex: 10,
                            padding: '10px',
                            cursor: 'pointer'
                        }}
                        onClick={handleClose}>
                        x
                    </div>
                    <div
                        style={{
                            position: 'absolute',
                            zIndex: 21,
                            top: '50%',
                            transform: 'translateY(-50%)',
                            left: '20px',
                            right: '20px',
                            height: '10%',
                            minHeight: '60px',
                            border: '3px solid yellow',
                            borderRadius: '4px',
                            boxShadow: '0 0 0 9999px rgba(0, 0, 0, 0.4)'
                        }}></div>
                    <button
                        style={{
                            position: 'absolute',
                            left: '50%',
                            top: 'calc(50% + 10% + 20px)',
                            transform: 'translateX(-50%)',
                            zIndex: 9,
                            borderRadius: '8px',
                            height: '44px',
                            padding: '0 24px',
                            fontSize: '16px',
                            fontWeight: '600',
                            backgroundColor: '#FFD700',
                            color: '#000',
                            border: 'none',
                            cursor: 'pointer'
                        }}
                        onClick={captureAndScan}>
                        { translate('insert') }
                    </button>
                </>
            )}
        </div>
    );
};

export default Scanner;
